import CollapsibleCard from "../site/CollapsibleCard";
import PVSummary from "../org/PVSummary";

const PVSummaryCard = () => {
  return (
    <CollapsibleCard title="PV Summary" initialOpen={false}>
      <PVSummary />
    </CollapsibleCard>
  );
};

export default PVSummaryCard;
